import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CompanyCard from '@components/ConnectionCard';
import CommunityActions from '~/actions/community';

const ReceivedRequests = ({ company, connections }) => {
    const dispatch = useDispatch();

    const handleConnect = (connection) => () => {
        const payload = {
            data: { payload: { connection_id: connection.id }, action: 'active' },
            after: { type: 'GETCOMPANYCONNECTIONS_REQUEST', payload: { company_id: company.id } },
        };
        dispatch(CommunityActions.postconnectionupdateRequest(payload));
    };

    const handleReject = (connection) => () => {
        const payload = {
            data: { payload: { connection_id: connection.id }, action: 'rejected' },
            after: { type: 'GETCOMPANYCONNECTIONS_REQUEST', payload: { company_id: company.id } },
        };
        dispatch(CommunityActions.postconnectionupdateRequest(payload));
    };

    return (
        <Row className="connections-received-request mx-1">
            {connections.map((connect) => (
                <Col key={connect.id} className="p-2" xs={12} sm={6} md={3}>
                    <CompanyCard data={connect} tab="received" onClick={handleConnect(connect)} onReject={handleReject(connect)} />
                </Col>
            ))}
        </Row>
    );
};

ReceivedRequests.propTypes = {
    company: PropTypes.shape({
        id: PropTypes.number,
    }),
    connections: PropTypes.array,
};

ReceivedRequests.defaultProps = {
    company: {
        id: 0,
    },
    connections: [],
};

export default ReceivedRequests;
